<device-manager>
  <div>
    <!-- Lista de dispositivos -->
    <device-list
      if={ state.view==='list' }
      devices={ state.devices }
      isAdmin={ props.isAdmin }
      onlogout={ handleLogout }
      ondevicesupdated={ handleDevicesUpdated }
      onrefreshdevices={ loadDevices }
      onviewdetails={ handleViewDetails }
    ></device-list>

    <!-- Detalles del dispositivo -->
    <device-detail if={ state.view==='detail' } deviceId={ state.currentDeviceId } onback={ handleBackToList }
      oneditschedule={ handleEditSchedule } ondeviceupdated={ handleDevicesUpdated }></device-detail>

    <!-- Incluir el componente de edición de horarios aquí para que sea accesible desde ambas vistas -->
    <schedule-editor id="scheduleEditorComponent" onschedulesaved={ handleScheduleSaved } deviceId={
      state.scheduleData.deviceId } deviceName={ state.scheduleData.deviceName } channelId={
      state.scheduleData.channelId } channelName={ state.scheduleData.channelName } schedule={
      state.scheduleData.schedule }></schedule-editor>

  </div>

  <script>
    import DeviceList from './device-list.riot'
    import DeviceDetail from './device-detail.riot'
    import ScheduleEditor from './schedule-editor.riot'
    import { DeviceService } from '../services/api-service'

    export default {
      components: {
        DeviceList,
        DeviceDetail,
        ScheduleEditor
      },

      onBeforeMount() {
        // Determinar la vista inicial basada en la URL aquí
        const initialUrlParams = new URLSearchParams(window.location.search);
        const initialDeviceId = initialUrlParams.get('id');
        const initialView = initialDeviceId ? 'detail' : 'list';

        this.state = {
          view: initialView, // <-- Establecer vista inicial correcta
          devices: this.props.devices || [],
          currentDeviceId: initialDeviceId, // <-- Establecer ID inicial correcto
          // Datos para el editor de schedule
          scheduleData: {
            deviceId: '',
            deviceName: '',
            channelId: '',
            channelName: '',
            schedule: null
          }
        };
      },

      onMounted() {
        // Ya no necesitamos determinar la vista inicial aquí
        // const urlParams = new URLSearchParams(window.location.search);
        // const deviceId = urlParams.get('id');
        // if (deviceId) {
        //   this.handleViewDetails(deviceId); // <-- ELIMINADO
        // }

        // Obtener referencia al componente schedule-editor
        this.scheduleEditorEl = document.getElementById('scheduleEditorComponent');

        // Agregar manejador para popstate
        window.addEventListener('popstate', this.handlePopState);
      },

      onBeforeUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
      },

      handlePopState(event) {
        const urlParams = new URLSearchParams(window.location.search);
        const deviceId = urlParams.get('id');
        const newView = deviceId ? 'detail' : 'list';

        // Solo actualizar si la vista o el ID realmente cambian
        if (newView !== this.state.view || deviceId !== this.state.currentDeviceId) {
          console.log(`[DeviceManager] PopState triggered: Updating view to ${newView}, deviceId: ${deviceId}`); // <-- Log útil
          this.update({
            view: newView,
            currentDeviceId: deviceId
          });
        } else {
          console.log(`[DeviceManager] PopState triggered: State already matches URL (view: ${this.state.view}), no update needed.`); // <-- Log útil
        }
      },

      // Métodos para cargar dispositivos
      async loadDevices() {
        try {
          const result = await DeviceService.getDevices();

          if (result.error) {
            console.error('Error loading devices:', result.error);
          } else {
            this.update({
              devices: result.devices
            });
          }
        } catch (error) {
          console.error('Error loading devices:', error);
        }
      },

      // Métodos para navegación entre vistas
      handleViewDetails(deviceId) {
        // Solo actualizar y pushear si la vista o ID cambian
        if (this.state.view !== 'detail' || this.state.currentDeviceId !== deviceId) {
          console.log(`[DeviceManager] handleViewDetails: Changing view to detail, deviceId: ${deviceId}`);
          this.update({
            view: 'detail',
            currentDeviceId: deviceId
          });

          // Actualizar la URL
          const url = new URL(window.location);
          url.searchParams.set('id', deviceId);
          window.history.pushState({}, '', url);
        } else {
          console.log(`[DeviceManager] handleViewDetails: Already in detail view for ${deviceId}, no update needed.`);
        }
      },

      handleBackToList() {
        // Solo actualizar y pushear si la vista no es 'list'
        if (this.state.view !== 'list') {
          console.log('[DeviceManager] handleBackToList: Changing view to list');
          this.update({
            view: 'list',
            currentDeviceId: null
          });

          // Actualizar la URL
          const url = new URL(window.location);
          url.searchParams.delete('id');
          window.history.pushState({}, '', url);
        } else {
          console.log('[DeviceManager] handleBackToList: Already in list view, no update needed.');
        }
      },

      // Métodos para el editor de horarios (schedule)
      handleEditSchedule(deviceId, deviceName, channel) {
        // Update the state with the schedule data
        this.update({
          scheduleData: {
            deviceId,
            deviceName,
            channelId: channel.channel,
            channelName: channel.name,
            schedule: channel.schedule
          }
        });

        // Find the schedule editor component
        const scheduleEditor = this.scheduleEditorEl;

        // If the component has an "open" method, use it
        if (scheduleEditor && scheduleEditor._tag && typeof scheduleEditor._tag.open === 'function') {
          scheduleEditor._tag.open(
            deviceId,
            deviceName,
            channel.channel,
            channel.name,
            channel.schedule
          );
        } else {
          // Fallback: access the modal through the DOM
          const scheduleModalElement = document.getElementById('scheduleModal');
          if (scheduleModalElement) {
            const modal = new bootstrap.Modal(scheduleModalElement);
            modal.show();
          }
        }
      },

      // Método para manejar cuando se guarda un horario
      handleScheduleSaved(data) {
        // Refrescar los datos del dispositivo
        this.handleDevicesUpdated();
      },

      // Método para cuando se actualiza un dispositivo
      handleDevicesUpdated() {
        if (this.props.ondevicesupdated) {
          this.props.ondevicesupdated();
        }
      },

      // Método para manejar cierre de sesión
      handleLogout() {
        if (this.props.onlogout) {
          this.props.onlogout();
        }
      }
    }
  </script>

</device-manager>
